import type { FC } from 'react';

import { useBoasVindas } from '../../../../logica/boasVindas/useBoasVindas';
import { BoasVindas } from './BoasVindas';

// /welcome — liga a lógica à tela.
const BoasVindasLigada: FC = () => <BoasVindas {...useBoasVindas()} />;

export default BoasVindasLigada;
